import { render, staticRenderFns } from "./SwitchedPriced.vue?vue&type=template&id=a06b0128&scoped=true&"
import script from "./SwitchedPriced.vue?vue&type=script&lang=ts&"
export * from "./SwitchedPriced.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchedPriced.vue?vue&type=style&index=0&id=a06b0128&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b0128",
  null
  
)

export default component.exports